module.exports = __webpack_public_path__ + "5b18a0254235a8bc3acfb7004f521c74.png";